/**
 * 课程筛选结果
 */
export default {
  loadMoreButtonName: 'En savoir plus',
  errorNotice: 'Le chargement a échoué, veuillez réessayer.',
  emptyNotice: 'Pas de cours dans cette catégorie. Parcourir les cours pour d\'autres classes/groupes d\'âge.',
}
